import React, { useState } from 'react';
import ContactForm from './ContactForm';
import { useServices } from '../../contexts/ServiceContext';
import { Contact } from 'common/model'; // Import your model

/**
 * 
 * @returns Component.
 */
export default function NewContact() {
    const { contactService } = useServices();
    const [savedContact, setSavedContact] = useState<Contact | undefined>(undefined);
    const [submitError, setSubmitError] = useState<string | undefined>(undefined);

    const handleSave = async (formData: any) => {
        setSubmitError(undefined);

        try {
            if (savedContact) {
                const editResponse = await contactService.edit({
                    Id: savedContact.Id as string,
                    FirstName: formData.firstName,
                    LastName: formData.lastName,
                    Email: formData.email,
                    JobTitle: formData.jobTitle,
                    CompanyName: formData.companyName,
                    CompanyWebsite: formData.companyWebsite,
                    LinkedInProfile: formData.linkedInProfile, // Ensure casing matches your fix!
                    IntroductionParagraph: formData.introduction,
                });

                setSavedContact(
                    {
                        Id: editResponse.id as string,
                        FacilitatorId: editResponse.facilitatorId as string,
                        CreatedAt: editResponse.createdAt as string,
                        Email: editResponse.email as string,
                        FirstName: editResponse.firstName as string,
                        LastName: editResponse.lastName as string,
                        JobTitle: editResponse.jobTitle,
                        CompanyName: editResponse.companyName,
                        CompanyWebsite: editResponse.companyWebsite,
                        LinkedInProfile: editResponse.linkedInProfile,
                        IntroductionParagraph: editResponse.introductionParagraph,
                        UpdatedAt: editResponse.updatedAt as string,
                    }
                );
            } else {

                const createResponse = await contactService.create({
                    FirstName: formData.firstName,
                    LastName: formData.lastName,
                    Email: formData.email,
                    JobTitle: formData.jobTitle,
                    CompanyName: formData.companyName,
                    CompanyWebsite: formData.companyWebsite,
                    LinkedInProfile: formData.linkedInProfile, // Ensure casing matches your fix!
                    IntroductionParagraph: formData.introduction
                });
                setSavedContact(
                    {
                        Id: createResponse.id as string,
                        FacilitatorId: createResponse.facilitatorId as string,
                        CreatedAt: createResponse.createdAt as string,
                        Email: createResponse.email as string,
                        FirstName: createResponse.firstName as string,
                        LastName: createResponse.lastName as string,
                        JobTitle: createResponse.jobTitle,
                        CompanyName: createResponse.companyName,
                        CompanyWebsite: createResponse.companyWebsite,
                        LinkedInProfile: createResponse.linkedInProfile,
                        IntroductionParagraph: createResponse.introductionParagraph,
                        UpdatedAt: createResponse.updatedAt as string,
                    }
                );
            }
        } catch (error) {
            setSubmitError("Something went wrong, please try again.");
        }
    };

    return (
        <ContactForm
            onSubmit={handleSave}
            contact={savedContact}
            error={submitError}
        />
    );
}
